import { css } from 'linaria';
import { breakpoints } from '../../../../../../media';

export const measureCard = css`
	${breakpoints.only.mobile} {
		flex-direction: row;
		column-gap: 8px;
		row-gap: 0;
	}
`;

export const titleStyles = css`
	display: block;
	margin-bottom: 12px;
`;

export const measureCardPrice = css`
	${breakpoints.only.mobile} {
		flex-direction: row !important;
		margin-top: 12px;
		column-gap: 16px;
		row-gap: 0;
	}
`;
